import { Col, GRID } from '../../components/custom';

export default function DOE()
{
    return (
        <Col id='DOE' className='usecase'>
            <Col className='banner'>
                <span className='title'>Use Case : Drivers of Employee's likelihood to recommend the company (eNPS)</span>
            </Col>
            <Col className='section objective'>
                <span className='title'>Objective</span>
                <span className='descsmall'>To identify which experience drivers most influence an employee's likelihood to <strong>recommend the company</strong> (proxy for engagement or eNPS).</span>
            </Col>
            <Col className='section methodology'>
                <span className='title'>Methodology</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Approach: Logistic Regression</span>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Dependent Variables</span>
                        <ul>
                            <li className='descsmall'><strong>Recommend Company</strong> (1 = Yes, 0 = No)</li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Independent Variables (Predictors)</span>
                        <ul>
                            <li className='descsmall'>Manager Support</li> 
                            <li className='descsmall'>Recognition</li>
                            <li className='descsmall'>Trust in Leadership</li>
                            <li className='descsmall'>Communication</li>
                        </ul>
                        <span className='descsmall'>Each predictor was treated as a continuous variable based on 1-5 Likert scale responses.</span>
                    </Col>
                </Col>
            </Col>
            <Col className='section results'>
                <span className='title'>Key Findings (Statistical Results)</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <GRID className='_4x5'>
                            <span className='descsmall bold'>Predictor</span>
                            <span className='descsmall bold'>Odds Ratio</span>
                            <span className='descsmall bold'>Significance (p-value)</span>
                            <span className='descsmall bold'>Interpretation</span>
                            <span className='descsmall bold left'>Recognition</span>
                            <span className='descsmall'>21.8x</span>
                            <span className='descsmall'>0.001</span>
                            <span className='descsmall left'>Employees who feel recognized are <strong>21x more likely</strong> to recommend the company.</span>
                            <span className='descsmall bold left'>Manager Support</span>
                            <span className='descsmall'>14.2x</span>
                            <span className='descsmall'>0.002</span>
                            <span className='descsmall left'>Strong support from managers increases recommendation odds by over <strong>14x.</strong></span>
                            <span className='descsmall bold left'>Trust in Leadership</span>
                            <span className='descsmall'>2.6x</span>
                            <span className='descsmall'>0.109</span>
                            <span className='descsmall left'>Moderate influence, not statistically significant.</span>
                            <span className='descsmall bold left'>Communication</span>
                            <span className='descsmall'>1.8x</span>
                            <span className='descsmall'>0.360</span>
                            <span className='descsmall left'>Weak and not significant in this model.</span>
                        </GRID>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Interpretation / Insights</span>
                        <ul>
                            <li className='descsmall'>Recognition and Manager Support are the strongest predictors of employee advocacy.</li>
                            <li className='descsmall'>Employees who feel <strong>appreciated and supported</strong> are far more likely to promote the company to others.</li>
                            <li className='descsmall'>Trust and communication matter too, but their effects are secondary in this model.</li>
                        </ul>
                    </Col>
                </Col>
            </Col>
        </Col>
    )
}